import React from "react";
import { pluralize } from "@common/helpers/string";
import { useCounterpartyTransactionsOpener } from "@hooks/useCounterpartyTransactionsOpener";
import { Button } from "@design-system/Button/Button";
import { CounterpartyVerifiedToastData } from "@design-system/ToastMessages/lib/counterpartyVerified";
import styles from "./CounterpartyVerifiedToast.module.scss";

type Props = CounterpartyVerifiedToastData;

export const CounterpartyVerifiedToast: React.FC<Props> = ({
    counterparty,
    transactionsNumber,
}) => {
    const transactionsOpener = useCounterpartyTransactionsOpener(
        counterparty.id,
        {
            includeDateFilter: false,
        },
    );

    return (
        <div className={styles.message}>
            <p>
                Assigned <strong>{counterparty.name}</strong> to{" "}
                {transactionsNumber}{" "}
                {pluralize("transaction", transactionsNumber)}
            </p>

            <footer className={styles.footer}>
                <Button
                    variant="secondary"
                    size="sm"
                    className={styles.review}
                    onClick={transactionsOpener}
                >
                    Review
                </Button>
            </footer>
        </div>
    );
};
